const filterSchema = {
    budget:1000000,
    name: /.*/i,
    cpu:/.*/i,
    gpu: /.*/i,
    ram: 8
}
export default filterSchema